import { Link } from "react-router-dom";
import { dramas } from "@/mocks/dramas";

const main = dramas.find((drama) => drama.id === "nanny") ?? dramas[0];

export default function FeaturedInsight() {
  return (
    <section className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between border-b border-background-200 px-4 py-4 md:px-5">
        <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-foreground-950">
          <i className="ri-quill-pen-line text-primary-500"></i>
          精选剧情解读与精彩片段
        </h2>
        <Link
          to={`/detail/${main.id}`}
          className="flex items-center gap-1 whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600"
        >
          查看全部
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 gap-4 p-4 md:p-5 lg:grid-cols-5">
        <article className="lg:col-span-2">
          <div className="h-44 w-full overflow-hidden rounded-lg bg-background-200 md:h-52">
            <img
              src={main.banner}
              alt={`${main.title} 剧情解读配图`}
              title={`${main.title} 剧情解析`}
              className="h-full w-full object-cover object-top"
            />
          </div>
          <h3 className="mt-3 font-heading text-base font-semibold text-foreground-950">
            《{main.title}》剧情深度解读
          </h3>
          <p className="mt-2 line-clamp-4 text-xs leading-relaxed text-foreground-600">{main.analysis}</p>
          <Link
            to={`/detail/${main.id}`}
            className="mt-3 inline-flex items-center gap-1 whitespace-nowrap text-xs font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            阅读完整解析
            <i className="ri-arrow-right-s-line"></i>
          </Link>
        </article>

        <div className="lg:col-span-3">
          <ul className="grid grid-cols-1 gap-3 sm:grid-cols-2">
            {main.clips.map((clip) => (
              <li key={clip.title}>
                <Link
                  to={`/detail/${main.id}`}
                  className="group block cursor-pointer overflow-hidden rounded-lg border border-background-200 transition-colors hover:border-primary-300"
                >
                  <div className="relative h-28 w-full overflow-hidden bg-background-200 md:h-32">
                    <img
                      src={clip.image}
                      alt={`${main.title} 片段 ${clip.title}`}
                      title={`${clip.title} 精彩片段`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <span className="absolute inset-0 flex items-center justify-center">
                      <span className="flex h-10 w-10 items-center justify-center rounded-full bg-foreground-950/50 text-background-50">
                        <i className="ri-play-fill text-xl"></i>
                      </span>
                    </span>
                    <span className="absolute bottom-2 right-2 rounded bg-foreground-950/70 px-1.5 py-0.5 text-[10px] text-background-50">
                      {clip.duration}
                    </span>
                  </div>
                  <div className="p-3">
                    <p className="text-sm font-medium text-foreground-900 transition-colors group-hover:text-primary-600">
                      {clip.title}
                    </p>
                    <p className="mt-1 line-clamp-2 text-[11px] leading-relaxed text-foreground-500">{clip.desc}</p>
                  </div>
                </Link>
              </li>
            ))}
          </ul>
          <p className="mt-3 flex items-center gap-1 text-[11px] text-foreground-400">
            <i className="ri-information-line"></i>
            温馨提示：片段预览为图文演示内容，暂不提供在线播放。
          </p>
        </div>
      </div>
    </section>
  );
}